import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import NewLCLDeviceDetail from './NewLCLDeviceDetail'
import LCLDeviceDetailMobile from './LCLDeviceDetailMobile'

const LCLDeviceDetailsWrapper: React.FC = (props) => {
    const isMobile = useMobileContext()
    return isMobile ? <LCLDeviceDetailMobile {...props} /> : <NewLCLDeviceDetail {...props} />
}
export default LCLDeviceDetailsWrapper